/*
 * faq.ts — FAQ accordion deep-linking (Registry & FAQ).
 *
 * Progressive: each Q&A is a native <details class="faq-item" id="faq-123">, so it
 * opens and closes with zero JS. This module only adds shareable deep links:
 * opening #faq-123 in the URL expands that item and scrolls to it, and opening an
 * item reflects its id back into the URL.
 */

export function initFaq(): void {
  const items = Array.from(document.querySelectorAll<HTMLDetailsElement>(".faq-item"));
  if (!items.length) return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const openFromHash = (): void => {
    const id = decodeURIComponent(location.hash.replace(/^#/, ""));
    if (!id) return;
    const target = document.getElementById(id);
    if (target instanceof HTMLDetailsElement && target.classList.contains("faq-item")) {
      target.open = true;
      target.scrollIntoView({
        behavior: reduceMotion ? "auto" : "smooth",
        block: "start",
      });
    }
  };

  openFromHash();
  window.addEventListener("hashchange", openFromHash);

  items.forEach((item) => {
    const summary = item.querySelector("summary");
    summary?.addEventListener("click", () => {
      // click fires before the toggle: !item.open here means it's about to open
      if (!item.open && item.id) {
        history.replaceState(null, "", `#${item.id}`);
      }
    });
  });
}
